export default "__VITE_ASSET__360ece30__"